export const validateEINFormat = (ein) => {
  if (!ein || typeof ein !== 'string') {
    return { isValid: false, error: 'EIN is required' };
  }

  const trimmedEIN = ein.trim();
  
  if (trimmedEIN === '') {
    return { isValid: false, error: 'EIN cannot be empty' };
  }

  const einPattern = /^(\d{9}|\d{2}-\d{7})$/;
  
  if (!einPattern.test(trimmedEIN)) {
    return { 
      isValid: false, 
      error: 'EIN must be 9 digits (e.g., 123456789) or in XX-XXXXXXX format (e.g., 12-3456789)' 
    };
  }

  return { isValid: true, error: null };
};
